import { render, staticRenderFns } from "./promotion-rag-colour-renderer-light.vue?vue&type=template&id=6a62983b&scoped=true"
import script from "./promotion-rag-colour-renderer-light.vue?vue&type=script&lang=js"
export * from "./promotion-rag-colour-renderer-light.vue?vue&type=script&lang=js"
import style0 from "./promotion-rag-colour-renderer-light.vue?vue&type=style&index=0&id=6a62983b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a62983b",
  null
  
)

export default component.exports